import { render, staticRenderFns } from "./Dropzone.vue?vue&type=template&id=64efca9a&"
import script from "./Dropzone.vue?vue&type=script&lang=ts&"
export * from "./Dropzone.vue?vue&type=script&lang=ts&"
import style0 from "./Dropzone.vue?vue&type=style&index=0&id=64efca9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports